export const inputType = {
    SLIDER: 'SLIDER',
    NUMBER: 'NUMBER',
    RADIO_SELECT: 'RADIO_SELECT',
    SELECT_NAME: 'SELECT_NAME'
};
